import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class JoinEvaluationTypeToFormTypeInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formTypeCode: string, reviewTypeId: number) {
    return this.formTypeService.joinEvaluationTypeToFormType(
      formTypeCode,
      reviewTypeId
    );
  }
}
